import { render, staticRenderFns } from "./presentation_resultatRecherche.vue?vue&type=template&id=715f85b4&scoped=true&"
import script from "./presentation_resultatRecherche.vue?vue&type=script&lang=js&"
export * from "./presentation_resultatRecherche.vue?vue&type=script&lang=js&"
import style0 from "./presentation_resultatRecherche.vue?vue&type=style&index=0&id=715f85b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f85b4",
  null
  
)

export default component.exports